import BaseComponent from '../../../js/base-component';
import { Modal } from '../../../js/modal';

class CareProductsStepTen extends BaseComponent {
    constructor(element) {
        super(element);

        let signform = this.element.querySelector('form[name="signform"]') || '';
        let sign = this.element.querySelectorAll('input[name="sign"]') || '';
        let checked = this.element.querySelector('input[name="sign"]:checked').value;
        let signature = this.element.querySelector('input[name="signature"]') || '';
        this.type = this.element.querySelector('input[name="type"]') || '';
        this.digital = this.element.querySelector('.u-care-products__fields--digital') || '';
        this.fullname = this.element.querySelector('input[name="fullname"]') || '';
        this.alternative = this.element.querySelector('.u-care-products__fields--alternative') || '';
        this.alternativeLabel = this.element.querySelector('.u-care-products__label--alternative') || '';
        this.email = this.element.querySelector('#email') || '';
        this.emailButton = this.element.querySelector('#emailButton') || '';
        this.downloadButton = this.element.querySelector('#download') || '';
        this.nextButton = this.element.querySelector('.is--care') || '';
        this.agreement = this.element.querySelector('#agreement') || '';

        this.body = document.querySelector('body') || '';
        this.modal = document.querySelector('.u-modal') || '';
        this.legalnotice = this.element.querySelector('#legalnotice') || '';
        this.legalnoticeModal = this.element.querySelector('#modal-legalnotice') || '';
        this.modalContent = `<h3>${this.legalnoticeModal.dataset.title}</h3><div class="bold">${ this.legalnoticeModal.dataset.headline}</div><div>${this.legalnoticeModal.dataset.content}</div>`
        this.modalContainer = document.querySelector('#contentModal') || '';
        this.modal = new Modal( this.modalContainer );
        this.signtext = this.element.querySelector('.u-care-products__sign-text span') || '';

        if ( this.agreement ) {
            this.agreement.addEventListener('click', this.checkConsent);
        }

        if ( this.legalnoticeModal ) {
            this.legalnoticeModal.addEventListener('click', (evt) => {
                evt.preventDefault();

                this.modal.handleModal('content','open', this.modalContent);
            });
        }

        if ( this.downloadButton ) this.downloadButton.addEventListener('click', this.disableMail);
        if ( this.legalnotice) this.legalnotice.addEventListener('click', this.checkConsent);
        if ( this.email ) this.email.addEventListener('input', this.checkEmail);

        sign.forEach((ele) => {
            ele.addEventListener("click", (e) => {
                if (e.target.value === 'digital') {
                    this.checkRadio( e.target.value, this.digital );
                    // show hidden next button
                    this.nextButton.classList.remove('hidden');
                    this.fullname.setAttribute('required','');
                }

                if (e.target.value === 'alternative') {
                    this.checkRadio( e.target.value, this.alternative );
                    this.fullname.removeAttribute('required');

                    // hide next button
                    this.nextButton.classList.add('hidden');
                }
            });
        });

        this.checkRadio( checked, this.digital );

        // disable button
        this.nextButton.setAttribute('disabled','');

        // -- signature pad
        this.canvas = this.element.querySelector("#u-signature-pad");

        const signaturePad = new SignaturePad(this.canvas, {
            penColor: 'rgb(55, 72, 179)',
            minDistance: 10,
        });

        signaturePad.addEventListener("beginStroke", () => {
            signaturePad.backgroundColor = "rgb(255, 255, 255)";
            signaturePad.clear();
        }, { once: true });

        signaturePad.addEventListener("endStroke", () => {
            // enable button
            this.nextButton.removeAttribute('disabled');
        });

        window.onresize = this.resizeCanvas();
        this.resizeCanvas();

        document.getElementById('clear').addEventListener('click', (e) => {
            e.preventDefault();

            signaturePad.clear();

            // disabled button
            this.nextButton.setAttribute('disabled','');
        });

        signform.addEventListener('submit', (e) => {
            e.preventDefault();

            let formData = new FormData(signform);

            // signature
            if (!signaturePad.isEmpty()) {
                // save image data in signature formfield and submit form
                signature.setAttribute('value', signaturePad.toDataURL('image/jpeg', 0.5));

                // reset email
                this.email.setAttribute('value','');
                this.type.setAttribute('value', 'digital');
                signform.submit();
            } else if (formData.get('legalnotice') && this.type.value === 'download') {
                // download pdf
                this.downloadFile(this.downloadButton.dataset.href, this.downloadButton.dataset.title);

                // set form action to thankyouUrl and submit form
                signform.setAttribute('action', this.downloadButton.dataset.url);
                setTimeout(() => {
                    signform.submit('', 'downlad');
                }, 1000);
            } else if (formData.get('email') !== '') {
                // email
                this.type.setAttribute('value', 'email');

                // set form action to thankyouUrl and submit form
                signform.setAttribute('action', this.emailButton.dataset.url);
                signform.submit();
            }
        });
    }

    onInit() {}

    hideContainer = (ele) => {
        ele.classList.add('hidden');
    }

    resizeCanvas = () => {
        let ratio =  Math.max(window.devicePixelRatio || 1, 1);

        this.canvas.width = this.canvas.offsetWidth * ratio;
        this.canvas.height = this.canvas.offsetHeight * ratio;
        this.canvas.getContext("2d").scale(ratio, ratio);
    }

    checkRadio = (state, ele)  => {
        if ( state === 'digital' ) {
           this.alternative.classList.add('hidden');
           this.alternativeLabel.classList.remove('bold');
           ele.classList.remove('hidden');
           this.legalnotice.checked = false;
           this.checkConsent();
        }

        if ( state === 'alternative' ) {
            this.digital.classList.add('hidden');
            this.alternativeLabel.classList.add('bold');
            ele.classList.remove('hidden');

            this.checkConsent();
        }
    }

    checkConsent = () => {
        let consent = false;
        if ((this.agreement && this.agreement.checked) || this.agreement === '') {
            consent = true;
        }

        if ( this.legalnotice.checked && consent) {
            this.downloadButton.classList.remove('disabled')
            this.downloadButton.classList.add('active');
            this.downloadButton.removeAttribute('disabled');

            // enable email validation / email button
            this.emailButton.removeAttribute('disabled');
            this.email.removeAttribute('disabled');
            this.email.setAttribute('required','');

            // check download file
            this.checkPDF(this.downloadButton.dataset.href);

            // check email
            this.checkEmail();
        } else {
            this.downloadButton.classList.add('disabled')
            this.downloadButton.classList.remove('active');
            this.downloadButton.setAttribute('disabled','');

            // disable email / email button
            this.emailButton.setAttribute('disabled','');
            this.email.setAttribute('disabled','');
            this.email.removeAttribute('required');

            // reset email
            // this.email.value = '';
        }
    }

    checkEmail = () => {
        if ( this.email.validity.valid && !this.emailButton.hasAttribute('disabled')) {
            this.emailButton.classList.remove('disabled')
            this.emailButton.classList.add('active');
        } else {
            this.emailButton.classList.add('disabled')
            this.emailButton.classList.remove('active');
        }
    }

    disableMail = () => {
        this.email.removeAttribute('required');
        // reset email
        this.email.value = '';

        this.type.setAttribute('value', 'download');
    }

    checkPDF = (url, check) => {
        fetch(url, { method: 'HEAD'})
            .then(response => {
                if (response.ok) {
                    this.downloadButton.classList.remove('loader');
                    this.downloadButton.classList.remove('disabled');
                    this.downloadButton.classList.add('active');
                    this.downloadButton.removeAttribute('disabled');

                    this.emailButton.classList.remove('loader');
                    this.emailButton.removeAttribute('disabled');
                    this.checkEmail();
                } else {
                    this.recheckPDF(url, check);
                }
            })
            .catch(error => {
                this.recheckPDF(url, check);
            });
    }

    // -- download pdfs
    downloadFile = (url, title) => {
        fetch(url, {
            mode: 'cors',
            method: 'GET',
            headers: {
                'Content-Type': 'application/pdf'
            },
        })
        .then(res => res.arrayBuffer())
        .then(res => {
            const file = new Blob([res], {type: 'application/octet-stream'});
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = title;

            link.click();
            link.remove();
        })
        .catch(error => {
            console.error('Download failed: ', error);
        });
    }

    setModalContent = (content) => {
        document.querySelector('.u-modal__content').innerHTML = content;
    };

    recheckPDF = (url, check) => {
        let checker = check || 0;

        this.downloadButton.classList.add('loader');
        this.downloadButton.classList.add('disabled')
        this.downloadButton.classList.remove('active');
        this.downloadButton.setAttribute('disabled','');

        this.emailButton.classList.add('loader');
        this.emailButton.setAttribute('disabled','');
        this.checkEmail();

        if (checker < 20) {
            setTimeout(() => {
                checker++;
                this.checkPDF( url, checker );
            }, "1000");
        } else if ( checker >= 20 ) {
            this.downloadButton.classList.remove('loader');
            this.emailButton.classList.remove('loader');
            // this.downloadButton.classList.add('error');
            // console.log('Download not ready!');
            this.modalErrorContent = `<h3>${this.downloadButton.dataset.title}</h3><div>${this.downloadButton.dataset.error}</div>`;
            this.modal.handleModal('content','open', this.modalErrorContent);
        }
    }
}

export default {
    name: 'CareProductsStepTen',
    definition: CareProductsStepTen
};